import React from 'react';
import { IconIndex } from '../utility/IconIndex';
import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const spinAnimation = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

const Spinner = styled(FontAwesomeIcon)`
    animation: ${spinAnimation} 1s linear infinite;
`

const Icon = ({ icon, ...props }) => {
    if (!IconIndex[icon]) return;
    return (
        icon === 'spinner'
            ? <Spinner icon={IconIndex[icon]} {...props} />
            : <FontAwesomeIcon icon={IconIndex[icon]} {...props} />
    );
}

export default Icon;